import { useCallback, useMemo, useState } from "react";

export function useDeleteConfirm() {
  const [pending, setPending] = useState(null);

  const requestDelete = useCallback((config) => {
    setPending(config);
  }, []);

  const closeDelete = useCallback(() => {
    setPending(null);
  }, []);

  const deleteModalProps = useMemo(() => {
    if (!pending) return { open: false };
    const { onConfirm, ...rest } = pending;
    return {
      open: true,
      ...rest,
      onCancel: closeDelete,
      onConfirm: async () => {
        await onConfirm?.();
        closeDelete();
      },
    };
  }, [pending, closeDelete]);

  return { requestDelete, closeDelete, deleteModalProps };
}
